import { defineRecipe } from '@chakra-ui/react';
export const textareaRecipe = defineRecipe({
    base: {
        colorPalette: 'primary',
    },
    variants: {
        size: {
            sm: {
                textStyle: 'sm',
                fontSize: 'sm',
                minHeight: '60px',
            },
            md: {
                textStyle: 'md',
                fontSize: 'md',
                minHeight: '80px',
            },
            lg: {
                textStyle: 'lg',
                fontSize: 'lg',
                minHeight: '100px',
            },
        },
        resize: {
            none: {
                resize: 'none',
            },
            vertical: {
                resize: 'vertical',
            },
            horizontal: {
                resize: 'horizontal',
            },
            both: {
                resize: 'both',
            },
        },
    },
    defaultVariants: {
        size: 'md',
        resize: 'vertical',
    },
});
